import { request } from "./request";

interface MedicareAmount {
  readonly id: number;
  readonly effective_date: Date;
  readonly deductible_phase_maximum: number;
  readonly initial_coverage_phase_coinsurance_percent: number;
  readonly gross_covered_drug_cost_maximum: number;
  readonly coverage_gap_phase_coinsurance_percent: number;
  readonly coverage_gap_gap_discount_amount_percent: number;
  readonly true_out_of_pocket_maximum: number;
  readonly catastrophic_phase_coinsurance_percent: number;
  readonly catastrophic_phase_generic_copay_amount: number;
  readonly catastrophic_phase_brand_copay_amount: number;
  readonly part_b_deductible_phase_maximum: number;
  readonly senior_savings_model_cost_share_maximum_amount: number;
  readonly out_of_pocket_threshold: number;
}
export interface PaymentEstimate {
  readonly month?: string;
  readonly true_out_of_pocket_amount?: string;
  readonly total_true_out_of_pocket_amount?: string;
  readonly billed_amount?: string;
  readonly total_billed_amount?: string;
  readonly is_estimate?: boolean;
}

export interface MedicarePrescriptionPaymentPlanEstimate {
  estimation: Omit<PaymentEstimate, "is_estimate">;
}

export interface MedicarePrescriptionPaymentPlanEstimateList {
  results: Array<MedicarePrescriptionPaymentPlanEstimate>;
  results_count: number;
}
export async function getPlanAmount(enrollment_plan_csid_id: number): Promise<MedicareAmount> {
  return await request<MedicareAmount>({
    url: "/medicare_amount/get",
    method: "POST",
    data: {
      enrollment_plan_csid_id: enrollment_plan_csid_id,
    },
  });
}

export async function getPlanEstimatePayments(
  enrollment_plan_csid_id: number,
  true_out_of_pocket_per_month: number,
  year: number,
  start_month: number,
): Promise<MedicarePrescriptionPaymentPlanEstimateList> {
  return await request<MedicarePrescriptionPaymentPlanEstimateList>({
    url: "/medicare_prescription_payment_plan/estimate_payment",
    method: "POST",
    data: {
      enrollment_plan_csid_id: enrollment_plan_csid_id,
      true_out_of_pocket_per_month: true_out_of_pocket_per_month,
      year: year,
      start_month: start_month,
    },
  });
}
